<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <h6>管理員管理</h6>
            <button class="btn btn-primary btn-sm mb-0">新增管理員</button>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      管理員
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      角色
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      加入時間
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="admin in admins" :key="admin.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div>
                          <img
                            :src="admin.avatar || 'https://placehold.co/100'"
                            class="avatar avatar-sm me-3"
                            alt="user1"
                          />
                        </div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ admin.name }}</h6>
                          <p class="text-xs text-secondary mb-0">
                            {{ admin.email }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ admin.role }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <soft-badge color="success" variant="gradient" size="sm">
                        啟用
                      </soft-badge>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">{{
                        new Date(admin.created_at).toLocaleDateString()
                      }}</span>
                    </td>
                    <td class="align-middle">
                      <a
                        href="javascript:;"
                        class="text-secondary font-weight-bold text-xs"
                        data-toggle="tooltip"
                        data-original-title="Edit user"
                      >
                        編輯
                      </a>
                    </td>
                  </tr>
                  <tr v-if="admins.length === 0">
                    <td colspan="5" class="text-center py-4 text-secondary">
                      暫無資料
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftBadge from "@/components/SoftBadge.vue";

export default {
  name: "Admins",
  components: {
    SoftBadge,
  },
  data() {
    return {
      admins: [
        {
          id: 1,
          name: "Admin User",
          email: "admin@goldshop.com",
          role: "超級管理員",
          created_at: "2023-01-01",
          avatar: null,
        },
      ],
    };
  },
};
</script>
